import template from './kform-file-label.html';
import controller from './kform-file-label.controller';

export default {
	controller,
	template,
	bindings: {
		file:      '<',
	},
	controllerAs: '$ctrl',
};
